var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideTabScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 7C32.8954 7 32 7.89543 32 9V21C32 22.1046 32.8954 23 34 23H40C41.1046 23 42 22.1046 42 21V9C42 7.89543 41.1046 7 40 7H34ZM30 12C29.4477 12 29 12.4477 29 13V17C29 17.5523 29.4477 18 30 18C30.5523 18 31 17.5523 31 17V13C31 12.4477 30.5523 12 30 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideTabScreen);
export default __webpack_public_path__ + "static/media/sideTabScreen.f0b34a9186d3187cacb039bb30ff690d.svg";
export { ForwardRef as ReactComponent };